import { render, staticRenderFns } from "./MdSetModuleDialog.vue?vue&type=template&id=367b4e8c&scoped=true&"
import script from "./MdSetModuleDialog.vue?vue&type=script&lang=js&"
export * from "./MdSetModuleDialog.vue?vue&type=script&lang=js&"
import style0 from "./MdSetModuleDialog.vue?vue&type=style&index=0&id=367b4e8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367b4e8c",
  null
  
)

export default component.exports